import { F0Box, F0Text } from '@factorialco/f0-react'
import { PerformanceGoalsMetricRowFragment } from 'generated/resources/graphql'
import { DocumentNode } from 'graphql'

import i18n from 'modules/core/lib/i18n'

import { KeyResultRow } from './KeyResultRow'

interface KeyResultsCardProps {
  metrics: PerformanceGoalsMetricRowFragment[]
  totalCount: number
  completedCount: number
  refetchQueries: DocumentNode[]
  showAssignee: boolean
  onAddKeyResult?: () => void
}

/**
 * KeyResultsCard displays the list of Key Results.
 * Each KR row shows: title, deadline, assignee, progress bar, editable value, status, and actions.
 */
export const KeyResultsCard: React.FC<KeyResultsCardProps> = ({
  metrics,
  totalCount,
  completedCount,
  refetchQueries,
  showAssignee,
}) => {
  return (
    <F0Box
      display="flex"
      flexDirection="column"
      gap="xl"
      border="default"
      borderRadius="lg"
      padding="lg"
    >
      <F0Box display="flex" flexDirection="row" justifyContent="between" alignItems="center">
        <F0Text variant="body" content={i18n.t('goals_revamp.detail.key_results_title')} />

        <F0Text
          variant="description"
          content={i18n.t('goals_revamp.detail.key_results_completed', {
            completed: completedCount,
            total: totalCount,
          })}
        />
      </F0Box>

      <F0Box display="flex" flexDirection="column" gap="lg">
        {metrics.map((metric) => (
          <KeyResultRow
            key={metric.id}
            metric={metric}
            refetchQueries={refetchQueries}
            showAssignee={showAssignee}
          />
        ))}
      </F0Box>
    </F0Box>
  )
}
